"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const company_entity_1 = require("./company.entity");
let CompanyDetail = class CompanyDetail {
    constructor(companyId, companyHistory, majorProducts, keyCustomers, documentsUploaded, businessProcesses, accountStrategy, targetingReason, competitor, weakness, actionPlan, potentialOpportunity, industryIntelligence, servicePlan, acquisitionHistory, bizProfile, servicePerformance, salesPitch, createdBy, updatedBy) {
        this.companyId = companyId;
        this.companyHistory = companyHistory;
        this.majorProducts = majorProducts;
        this.keyCustomers = keyCustomers;
        this.documentsUploaded = documentsUploaded;
        this.businessProcesses = businessProcesses;
        this.accountStrategy = accountStrategy;
        this.targetingReason = targetingReason;
        this.competitor = competitor;
        this.weakness = weakness;
        this.actionPlan = actionPlan;
        this.potentialOpportunity = potentialOpportunity;
        this.industryIntelligence = industryIntelligence;
        this.servicePlan = servicePlan;
        this.acquisitionHistory = acquisitionHistory;
        this.bizProfile = bizProfile;
        this.servicePerformance = servicePerformance;
        this.salesPitch = salesPitch;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.CompanyDetail = CompanyDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyDetail.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_history", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "companyHistory", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "major_products", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "majorProducts", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "key_customers", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "keyCustomers", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "documents_uploaded", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "documentsUploaded", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "business_processes", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "businessProcesses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "account_strategy", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "accountStrategy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "targeting_reason", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "targetingReason", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "competitor", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "competitor", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "weakness", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "weakness", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "action_plan", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "actionPlan", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "potential_opportunity", type: "text", nullable: true }) // Add potential_opportunity
    ,
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "potentialOpportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "industry_intelligence", type: "text", nullable: true }) // Add industry_intelligence
    ,
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "industryIntelligence", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "service_plan", type: "text", nullable: true }) // Add service_plan
    ,
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "servicePlan", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "acquisition_history", type: "text", nullable: true }) // Add acquisition_history
    ,
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "acquisitionHistory", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "biz_profile", type: "text", nullable: true }) // Add biz_profile
    ,
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "bizProfile", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "service_performance", type: "text", nullable: true }) // Add service_performance
    ,
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "servicePerformance", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "sales_pitch", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], CompanyDetail.prototype, "salesPitch", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CompanyDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CompanyDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], CompanyDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], CompanyDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], CompanyDetail.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Object)
], CompanyDetail.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => CompanyDetail, (detail) => detail.company, { cascade: true }),
    (0, typeorm_1.JoinColumn)({ name: "id", referencedColumnName: "companyId" }),
    tslib_1.__metadata("design:type", Object)
], CompanyDetail.prototype, "details", void 0);
exports.CompanyDetail = CompanyDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("company_detail"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, String, String, String, String, String, String, String, String, String, String, String, String, String, String, String, Number, Number])
], CompanyDetail);
